import { useContext } from 'react';
import { TailwindThemeContext } from '../../contexts/tailwindThemeContext';

const useTailwind = () => {
  const context = useContext(TailwindThemeContext);
  if (context === undefined) throw new Error('Invalid tailwind theme context.');

  return {
    tailwind: context.tailwind,
    setTailwind: context.setTailwind,
  };
};

export { useTailwind };
